<template>
  <!-- begin:: Header Topbar -->
  <div class="topbar">
    <div class="topbar-item">
      <div
        class="btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2"
      >Баланс: {{formatNumber(user.balance)}}</div>
    </div>

    <!--begin: User Bar -->
    <KTQuickUser></KTQuickUser>
    <!--end: User Bar -->
  </div>
  <!-- end:: Header Topbar -->
</template>

<style lang="scss">
.topbar {
  .dropdown-toggle {
    padding: 0;
    &:hover {
      text-decoration: none;
    }

    &.dropdown-toggle-no-caret {
      &:after {
        content: none;
      }
    }
  }

  .dropdown-menu {
    margin: 0;
    padding: 0;
    .b-dropdown-text {
      padding: 0;
    }
  }
}
</style>

<script>
import KTQuickUser from "@/view/layout/extras/offcanvas/QuickUser.vue";
import i18nService from "@/core/services/i18n.service.js";

export default {
  name: "KTTopbar",
  data() {
    return {
      languageFlag: "",
      languages: i18nService.languages
    };
  },
  components: {
    KTQuickUser
  },
  methods: {
    onLanguageChanged() {
      this.languageFlag = this.languages.find(val => {
        return val.lang === i18nService.getActiveLanguage();
      }).flag;
    },
    formatNumber(value) {
      var formatter = new Intl.NumberFormat("ru-RU", {
        style: "currency",
        currency: "RUB"
      });

      return formatter.format(value || 0);
    }
  },
  computed: {
    getLanguageFlag() {
      return this.onLanguageChanged();
    },
    user() {
      return this.$store.state.auth.user;
    }
  }
};
</script>
